// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.issue-card-container {
  width: 690px;
  margin: 0 1rem; }
  .issue-card-container .form-container .fix-width.w-50 {
    flex-wrap: wrap;
    width: 100%; }
    @media screen and (min-width: 768px) {
      .issue-card-container .form-container .fix-width.w-50 {
        flex-wrap: unset; } }
    .issue-card-container .form-container .fix-width.w-50 .MuiFormControl-root {
      width: 100% !important; }
      @media screen and (min-width: 768px) {
        .issue-card-container .form-container .fix-width.w-50 .MuiFormControl-root {
          width: 50% !important; } }
      @media screen and (min-width: 768px) {
        .issue-card-container .form-container .fix-width.w-50 .MuiFormControl-root:first-child {
          width: calc(50% - 15px) !important;
          margin-right: 15px; } }
  @media screen and (min-width: 768px) {
    .issue-card-container .form-container .field-container {
      margin-top: 12px; } }
  .issue-card-container .action-footer button {
    width: 100%;
    font-size: 16px;
    margin-bottom: 14px; }
    @media (min-width: 720px) {
      .issue-card-container .action-footer button {
        width: calc(50% - 7px); }
        .issue-card-container .action-footer button:first-child {
          margin-right: 14px; } }
  .issue-card-container .schedule-picker {
    margin: 0 0 30px 0;
    width: 50%; }
    .issue-card-container .schedule-picker.date-error .date-picker-field {
      border-bottom: 2px solid #ff5353; }
    .issue-card-container .schedule-picker .react-datepicker-wrapper {
      width: 100%; }
      .issue-card-container .schedule-picker .react-datepicker-wrapper .date-picker-field {
        min-width: unset; }

.loading-container {
  margin-top: 30px;
  text-align: center; }

.title {
  margin-bottom: 10px; }

/*
.bulk-card-header {
  display: flex;
  flex-direction: column;
}
*/
.issue-card-body {
  margin-top: 100px; }
  .issue-card-body .form-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    margin-left: 30px; }
  .issue-card-body .bulk-card-body .row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px; }
  .issue-card-body .bulk-card-body .action-footer {
    margin-top: 20px; }
    .issue-card-body .bulk-card-body .action-footer .action-btn {
      color: #fffb00;
      border: 2px solid #fffb00;
      border-radius: 30px;
      width: 336px;
      height: 48px;
      margin-right: 20px; }
`, "",{"version":3,"sources":["webpack://./src/pages/issue-card/initialStep/initialStep.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc,EAAA;EAFhB;IAMM,eAAe;IACf,WAAW,EAAA;IAEX;MATN;QAUQ,gBAAgB,EAAA,EAiBnB;IA3BL;MAcQ,sBAAsB,EAAA;MAEtB;QAhBR;UAiBU,qBAAqB,EAAA,EASxB;MALG;QArBV;UAsBY,kCAAkC;UAClC,kBAAkB,EAAA,EAErB;EAIL;IA7BJ;MA+BQ,gBAAgB,EAAA,EACjB;EAhCP;IA4CM,WAAW;IACX,eAAe;IACf,mBAAmB,EAAA;IAEnB;MAhDN;QAiDQ,sBAAsB,EAAA;QAjD9B;UAoDU,kBAAkB,EAAA,EACnB;EArDT;IA+DI,kBAAkB;IAClB,UAAU,EAAA;IAhEd;MA4DM,gCAAgC,EAAA;IA5DtC;MAoEM,WAAW,EAAA;MApEjB;QAuEQ,gBAAgB,EAAA;;AAOxB;EACE,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;;;;;CAnCC;AAyCD;EACE,iBAAiB,EAAA;EADnB;IAII,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB,EAAA;EARrB;IAcM,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB,EAAA;EAjBzB;IAqBM,gBAAgB,EAAA;IArBtB;MAwBQ,cAAc;MACd,yBAAyB;MACzB,mBAAmB;MACnB,YAAY;MACZ,YAAY;MACZ,kBAAkB,EAAA","sourcesContent":[".issue-card-container {\n  width: 690px;\n  margin: 0 1rem;\n\n  .form-container {\n    .fix-width.w-50 {\n      flex-wrap: wrap;\n      width: 100%;\n\n      @media screen and (min-width: 768px) {\n        flex-wrap: unset;\n      }\n\n      .MuiFormControl-root {\n        width: 100% !important;\n\n        @media screen and (min-width: 768px) {\n          width: 50% !important;\n        }\n\n        &:first-child {\n          @media screen and (min-width: 768px) {\n            width: calc(50% - 15px) !important;\n            margin-right: 15px;\n          }\n        }\n      }\n    }\n\n    @media screen and (min-width: 768px) {\n      .field-container {\n        margin-top: 12px;\n      }\n    }\n\n    // .fix-width > .MuiFormControl-root {\n    //   @media screen and (min-width: 768px) {\n    //     width: 50% !important;\n    //   }\n    // }\n  }\n\n  .action-footer {\n    button {\n      width: 100%;\n      font-size: 16px;\n      margin-bottom: 14px;\n\n      @media (min-width : 720px) {\n        width: calc(50% - 7px);\n\n        &:first-child {\n          margin-right: 14px;\n        }\n      }\n    }\n  }\n\n  .schedule-picker {\n    &.date-error .date-picker-field {\n      border-bottom: 2px solid #ff5353;\n    }\n\n    margin: 0 0 30px 0;\n    width: 50%;\n\n\n    .react-datepicker-wrapper {\n      width: 100%;\n\n      .date-picker-field {\n        min-width: unset;\n      }\n    }\n\n  }\n}\n\n.loading-container {\n  margin-top: 30px;\n  text-align: center;\n}\n\n.title {\n  margin-bottom: 10px;\n}\n\n/*\n.bulk-card-header {\n  display: flex;\n  flex-direction: column;\n}\n*/\n.issue-card-body {\n  margin-top: 100px;\n\n  .form-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 20px;\n    margin-left: 30px;\n  }\n\n\n  .bulk-card-body {\n    .row {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      margin-bottom: 20px;\n    }\n\n    .action-footer {\n      margin-top: 20px;\n\n      .action-btn {\n        color: #fffb00;\n        border: 2px solid #fffb00;\n        border-radius: 30px;\n        width: 336px;\n        height: 48px;\n        margin-right: 20px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
